















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  setup(_props, { emit }) {
    const handleClose = () => {
      emit('close');
    };
    return {
      handleClose,
    };
  },
});
